import { c as _c } from "react/compiler-runtime";
import { FunnelStepActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/funnel-step-actions';
import { useOfferFormSettings } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/hooks/use-offer-form-settings';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import type { FunnelStepPageActionsProps } from 'modules/funnels/funnel/types/funnel-step-page-actions-props';
import { getFunnelStepPreviewUrl, getStepPreviewUrl } from 'modules/funnels/funnel/utils/page-utils';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface OfferFunnelStepActionsProps extends FunnelStepPageActionsProps {
  showPreview?: boolean;
}
function OfferFunnelStepActions(t0) {
  const $ = _c(16);
  const {
    funnelId,
    funnelStep,
    pageId,
    showPreview
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    funnel
  } = useFunnel(funnelId);
  const {
    offerFormSettings
  } = useOfferFormSettings(funnelStep.id);
  let t1;
  if ($[0] !== funnel || $[1] !== funnelStep.inRunningSplitTest || $[2] !== offerFormSettings || $[3] !== showPreview) {
    t1 = () => {
      if (!funnel || !offerFormSettings) {
        return;
      }
      const {
        domainName
      } = funnel.domain;
      const {
        path
      } = offerFormSettings.page;
      return showPreview ? getFunnelStepPreviewUrl(domainName, path) : getStepPreviewUrl(domainName, path, funnelStep.inRunningSplitTest);
    };
    $[0] = funnel;
    $[1] = funnelStep.inRunningSplitTest;
    $[2] = offerFormSettings;
    $[3] = showPreview;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getViewLinkUrl = t1;
  const t2 = funnelStep.id;
  let t3;
  if ($[5] !== getViewLinkUrl) {
    t3 = getViewLinkUrl();
    $[5] = getViewLinkUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== funnelStep.inRunningSplitTest || $[8] !== t) {
    t4 = funnelStep.inRunningSplitTest ? t("dashboard.funnel.configuration.common.in_split_test_not_available") : undefined;
    $[7] = funnelStep.inRunningSplitTest;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== funnelId || $[11] !== funnelStep.id || $[12] !== pageId || $[13] !== t3 || $[14] !== t4) {
    t5 = <FunnelStepActions funnelId={funnelId} funnelStepId={t2} pageId={pageId} viewLinkUrl={t3} editDisabledReason={t4} />;
    $[10] = funnelId;
    $[11] = funnelStep.id;
    $[12] = pageId;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
export { OfferFunnelStepActions };